import React from 'react';
import { CheckCircle, XCircle, AlertCircle } from 'lucide-react';

const MessageAlert = ({ message, styles }) => {
  if (!message.text) return null;

  return (
    <div style={styles.message(message.type)}>
      {message.type === 'success'
        ? <CheckCircle size={20} />
        : message.type === 'error'
        ? <XCircle size={20} />
        : <AlertCircle size={20} />}
      {message.text}
    </div>
  );
};

export default MessageAlert;